import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { RequestTypes } from '@core/react-query/features/analytics/requestTypes'
import { analyticsKeys } from '@core/react-query/features/analytics'
import { IAnalyticsDashboardGraphicData } from '@core/entities/analytics/AnalyticsDashboard/graphics/IAnalyticsGraphicData'
import { RequestErrorType } from '@core/utils/api-axios-instance'

export const useLoadAnalyticsGraphic = (
  payload: RequestTypes['loadAnalyticsGraphic'],
  options?: UseQueryOptions<IAnalyticsDashboardGraphicData, RequestErrorType>,
) => {
  return useQuery({
    ...analyticsKeys.loadAnalyticsGraphic(payload),
    ...options,
    keepPreviousData: true,
  })
}
